import React, {Fragment} from "react";
import styled from "styled-components";
import {
	getScheduleType,
	getScheduleTypeName,
	getScheduleTypeColor,
	getScheduleStateName,
	getScheduleStateColor
} from "utils/define";
import "utils/format";
import defaultThumbnail from "assets/image/default_coach_thumbnail.svg";
import Badge from "components/ui/Badge";



/**
 * [스케줄 요약 정보]
 */

export const SummaryInfo = ({mode, data, ...props}) => {
	const scheduleType = getScheduleType(data);
	const scheduleTypeName = getScheduleTypeName(data, "kr");
	const memberName = (data.seqMember) ? data.memberName :
		<Fragment>
			{data.nonmemberName}
			<span className="gray"> 비회원</span>
		</Fragment>;

	const getTop = () => {
		let scheduleStateName = getScheduleStateName(data.scheduleState);
		let scheduleStateColor = getScheduleStateColor(data.scheduleState);
		const serviceTypeColor = getScheduleTypeColor(scheduleType);
		if(data.scheduleState == "C") {
			scheduleStateName = "수업취소";
			scheduleStateColor = "red";
		}

		const getScheduleStateInfo = () => {
			if(scheduleType != "CLASS") return null;
			if(data?.scheduleState === "O") return <span className="red">폐강</span>
			return (data.scheduleState == "C") ?
				<span className="red">수업취소</span> :
				(new Date() < new Date(data.startDate)) ?
				<span className="blue">모집중</span> : <span className="green">모집완료</span>;
		};

		const getReservationInfo = () => {
			if(scheduleType == "ETC") return null;
			const reservationCount = data.reservationCount || 0;
			const reservationColor = (reservationCount) ? "blue" : "gray";
			const lessonMaximumNo = data.lessonMaximumNo || 0;
			return (scheduleType != "CLASS") ? (
				<div className="right">
					<span>{memberName || "-"}</span>
					<span className={scheduleStateColor}>{scheduleStateName}</span>
				</div>
			) : (
				<div className="right">
					{
						(mode == "list") ?
							<span>
								<var className={reservationColor}>{reservationCount}</var>
								<var> / {lessonMaximumNo}</var>
							</span> :
						<span>정원 {data.lessonMaximumNo}</span>
					}
					{getScheduleStateInfo()}
				</div>
			);
		};

		return (
			<div className="top">
				<div className={"left " + serviceTypeColor}>
					{scheduleTypeName}
					{data.hasNaverBooking === "Y" && <Badge color="green">네이버 예약</Badge>}
				</div>
				{getReservationInfo()}
			</div>
		);
	};

	const getMiddle = () => {
		const getPartnerName = () => {
			return data.partnerName + " " + (data.branchName || "");
		};
		const getSpaceName = () => {
			return (data.spaceName) ? " · " + data.spaceName : "";
		};
		const getScheduleName = () => {
			const scheduleName = ((scheduleType == "APPOINTMENT") ? data.passName : data.lessonName) || "-";
			return scheduleName.recoverTag();
		};
		const getScheduleNameEtc = () => {
			if(scheduleType==='ETC') {
				return (
					<h4 className={(data.scheduleName) ? "memo" : "memo empty"}>{data.scheduleName || ""}</h4>
				)
			}
			return (
				<h4 className={(data.memo) ? "memo" : "memo empty"}>{data.memo || ""}</h4>
			)
		};
		return (
			<div className="middle">
				{
					(scheduleType == "APPOINTMENT" || scheduleType == "CLASS") ?
						<h4>{getScheduleName()}</h4> :
						getScheduleNameEtc()
				}
				{
					scheduleType === "ETC" && mode === 'info' && (
						<p>{data.memo}</p>
					)
				}
				{
					(mode == "list") ?
						(scheduleType == "CLASS") ? <h5>{data.spaceName || "-"}</h5> : null :
						<h5>{getPartnerName()} {getSpaceName()}</h5>
				}
			</div>
		);
	};

	const getBottom = () => {
		return (
			<div className="bottom">
				<div className="coachInfo">
					<img src={data.coachImage || defaultThumbnail} />
					{data.coachName} 강사
				</div>
			</div>
		);
	};

	const getClassName = () => {
		const nameList = [];
		nameList.push("color");
		nameList.push(scheduleType.toLowerCase());
		nameList.push(mode.toLowerCase());
		return nameList.join(" ");
	};

	return (
		<Wrapper className={getClassName()} {...props}>
			{getTop()}
			{getMiddle()}
			{getBottom()}
		</Wrapper>
	);
};

const Wrapper = styled.div`
&								{position:relative; padding:16px 16px 16px 24px; line-height:1}
&:before						{content:""; position:absolute; top:14px; bottom:14px; left:10px; width:2px; background-color:var(--appointment)}
&.etc:before					{background-color:var(--black)}
&.class:before					{background-color:var(--class)}

.top							{display:flex; justify-content:space-between; font-size:var(--12px)}
.top .left						{font-weight:600}
.top .left em					{margin-left:5px; padding:3px 6px; border-radius:20px; border:1px solid rgba(57,115,255,0.5); font-size:var(--10px); color:#3973ff}
.top .left em.close				{border-color:var(--gray); color:var(--darkGray)}
.top .left .badge				{margin-left:8px; padding:2px 6px; font-size:var(--11px); border-radius:4px; vertical-align:middle}
.top .right span				{font-weight:600}
.top .right span + span:before	{content:""; display:inline-block; vertical-align:middle; margin:0 0.5em; height:1em; border-left:1px solid #d6d9de}


.middle							  {margin-top:10px}
.middle h4						{font-size:var(--16px); font-weight:600}
.middle p						  {margin-top:4px; font-size:var(--16px); line-height:24px; font-weight:normal; color:#515458; letter-spacing:-0.4px;}
.middle h5						{margin-top:8px; font-size:var(--12px); font-weight:normal; color:var(--darkGray)}
.middle .memo					{display:-webkit-box; -webkit-box-orient:vertical; max-height:4.5em; -webkit-line-clamp:3; overflow:hidden}
.middle .memo					{margin-top:-2px; line-height:1.45; text-align:justify; font-size:var(--14px); font-weight:600}
.middle .memo.empty:before		{content:"✏️ 입력한 메모가 없어요."; color:var(--gray)}

.bottom                   {margin-top:14px}
.bottom .coachInfo				{display:flex; align-items:center; font-size:var(--14px)}
.bottom .coachInfo img			{margin-right:6px; width:24px; height:24px; background-color:var(--lightGray); border-radius:100%; object-fit:cover}

&.info							{padding:4px 0 4px 15px}
&.info:before					{left:0; top:0; bottom:0}
&.info .top,
&.info .middle h5				{font-size:var(--14px)}
&.info .top em					{vertical-align:middle; padding:4.5px 8px; font-size:var(--11px)}
&.info .top .right span			{font-weight:normal}
&.info .top .right span + span	{font-weight:600}
&.info .middle h4				    {font-size:var(--22px)}
&.info .middle h4.memo			{display:block; max-height:inherit; font-size:var(--16px);line-height: 24px}
&.info .bottom							{margin-top:18px}
&.info .bottom .coachInfo		{font-size:var(--16px)}
&.info .bottom .coachInfo img	{width:40px; height:40px; margin-right:10px}
`;

export default SummaryInfo;
